/**
 * Dev Workbench shared constants
 */

export const API_BASE = process.env.REACT_APP_API_BASE_URL || 'https://getclearance-production.up.railway.app/api/v1';

// All 21 primitives from the portal
export const PRIMITIVES = [
  // Screening
  { id: 'screening.individual', label: 'Screening', category: 'Screening' },
  { id: 'screening.company', label: 'Company Screening', category: 'Screening' },
  { id: 'screening.wallet', label: 'Wallet Screening', category: 'Screening' },
  // Biometrics
  { id: 'biometrics.face_compare', label: 'Face Match', category: 'Biometrics' },
  { id: 'biometrics.passive_liveness_free', label: 'Liveness Basic', category: 'Biometrics' },
  { id: 'biometrics.liveness_detect', label: 'Liveness Premium', category: 'Biometrics' },
  { id: 'biometrics.age_estimation', label: 'Age Estimate', category: 'Biometrics' },
  { id: 'biometrics.face_quality', label: 'Face Quality', category: 'Biometrics' },
  { id: 'biometrics.face_search', label: 'Face Search', category: 'Biometrics' },
  // Document
  { id: 'document.ocr', label: 'Document OCR', category: 'Document' },
  { id: 'document.ocr_free', label: 'Document OCR Free', category: 'Document' },
  { id: 'document.classify', label: 'Document Classify', category: 'Document' },
  { id: 'document.fraud_free', label: 'Document Fraud', category: 'Document' },
  // Device Intel
  { id: 'device_intel.ip_check', label: 'IP Check', category: 'Device Intel' },
  { id: 'device_intel.email_check', label: 'Email Check', category: 'Device Intel' },
  { id: 'device_intel.phone_check', label: 'Phone Check', category: 'Device Intel' },
  // Identity & Compliance
  { id: 'identity.match', label: 'Identity Match', category: 'Identity' },
  { id: 'compliance.address_verify', label: 'Address Verify', category: 'Compliance' },
  // AI
  { id: 'ai.risk_summary', label: 'Risk Summary', category: 'AI' },
  { id: 'ai.document_fraud', label: 'Document Fraud AI', category: 'AI' },
];

export const DEFAULT_INPUTS = {
  // Screening
  'screening.individual': { name: "Jane CLEAR", birth_date: "1990-01-15", countries: ["US"], threshold: 0.5 },
  'screening.company': { name: "Acme Corporation", jurisdiction: "US", registration_number: "12345678" },
  'screening.wallet': { address: "0x1234567890abcdef1234567890abcdef12345678", chain: "ethereum" },
  // Biometrics
  'biometrics.face_compare': { source_image: "https://example.com/selfie.jpg", target_image: "https://example.com/id.jpg" },
  'biometrics.passive_liveness_free': { image: "https://example.com/face.jpg" },
  'biometrics.liveness_detect': { image: "https://example.com/face.jpg" },
  'biometrics.age_estimation': { image: "https://example.com/face.jpg", min_age: 21 },
  'biometrics.face_quality': { image: "https://example.com/face.jpg" },
  'biometrics.face_search': { image: "https://example.com/face.jpg", collection_id: "default" },
  // Document
  'document.ocr': { storage_key: "documents/test-passport.jpg", document_type: "passport" },
  'document.ocr_free': { storage_key: "documents/test-passport.jpg", document_type: "passport" },
  'document.classify': { storage_key: "documents/test-document.jpg" },
  'document.fraud_free': { storage_key: "documents/test-document.jpg" },
  // Device Intel
  'device_intel.ip_check': { ip_address: "1.1.1.1" },
  'device_intel.email_check': { email: "legitimate@gmail.com" },
  'device_intel.phone_check': { phone_number: "+14155551234" },
  // Identity & Compliance
  'identity.match': { phone_number: "+14155551234", first_name: "Jane", last_name: "Clear", date_of_birth: "1990-01-15", ssn: "111-11-1111" },
  'compliance.address_verify': { street: "1600 Amphitheatre Parkway", city: "Mountain View", state: "CA", postal_code: "94043", country: "US" },
  // AI
  'ai.risk_summary': { applicant_id: "test-applicant-123" },
  'ai.document_fraud': { storage_key: "documents/test-document.jpg" },
};

// Magic test data reference
export const MAGIC_VALUES = {
  screening: {
    title: 'Screening Names',
    values: [
      { input: 'Jane CLEAR', result: 'clear', description: 'No matches found' },
      { input: 'John MATCH', result: 'potential_match', description: 'Triggers review' },
      { input: 'Bob SANCTIONED', result: 'match', description: 'Blocked - critical risk' },
    ]
  },
  identity: {
    title: 'SSN Values',
    values: [
      { input: '111-11-1111', result: 'match', description: '99% confidence match' },
      { input: '123-45-6789', result: 'partial_match', description: '65% confidence' },
      { input: '000-00-0000', result: 'no_match', description: 'No record found' },
    ]
  },
  ip: {
    title: 'IP Addresses',
    values: [
      { input: '1.1.1.1', result: 'low', description: 'Clean Cloudflare DNS' },
      { input: '10.0.0.1', result: 'medium', description: 'VPN detected' },
      { input: '127.0.0.1', result: 'critical', description: 'Tor + fraud history' },
    ]
  },
  email: {
    title: 'Email Addresses',
    values: [
      { input: 'legitimate@gmail.com', result: 'low', description: 'Established account' },
      { input: 'temp12345@tempmail.com', result: 'high', description: 'Disposable email' },
      { input: 'fraud@scammer.fake', result: 'critical', description: 'Known fraud' },
    ]
  },
};

export const TABS = [
  { id: 'explorer', label: 'Explorer', icon: 'Play' },
  { id: 'logs', label: 'Logs', icon: 'FileText' },
  { id: 'quickstart', label: 'Quickstart', icon: 'BookOpen' },
  { id: 'keys', label: 'API Keys', icon: 'Key' },
  { id: 'webhooks', label: 'Webhooks', icon: 'Webhook' },
];
